var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoeMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0995EB",
    fillRule: "nonzero",
    d: "M16.367 20.835h1.504c.762 0 1.387-.58 1.477-1.323l1.496-14.935h-4.532V.907h-1.785v3.67h-4.504l.272 2.12c1.55.426 3 1.196 3.87 2.048 1.305 1.287 2.202 2.62 2.202 4.794v7.296zm-15.46-.907v-.897h13.62v.897c0 .499-.408.907-.915.907H1.822c-.508 0-.916-.408-.916-.907zm13.62-6.343c0-7.25-13.62-7.25-13.62 0h13.62zM.924 15.406h13.594v1.813H.924v-1.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoeMenuIcon);
export default __webpack_public_path__ + "static/media/doe-menu-icon.c11edc44.svg";
export { ForwardRef as ReactComponent };